<template>
  <!-- 汇率详情 -->
  <div class="exchange-rate-list">
    <ab-list-query>
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <ab-select
              v-model="formSearch.sourceCurrencyDesc"
              url="/bas/basCurrency/list"
              placeholder="币别"
              @handleSelect="sourceCurrencySelect"
            ></ab-select>
          </el-col>
          <el-col :span="4">
            <ab-timeSearch
              class="searchBox"
              startSrc="日期起"
              endSrc="日期止"
              v-model="formSearch.queryDateArray"
              @searchEvent="queryDateChange"
            ></ab-timeSearch>
          </el-col>
          <el-col
            :span="4"
            class="text-left"
          >
            <el-button @click="searchForm">搜索</el-button>
            <el-button
              link
              class="btn-svg"
              @click="resetForm"
            >
              <ab-svg name="qingchu"></ab-svg>清除
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #toolbar>
        <el-button
          type="primary"
          :loading="loading.export"
          @click="exportFile"
        >导出</el-button>
      </template>

      <template #table>
        <ab-table
          class="materialTable"
          ref="table"
          stripe
          isFilter="spotSellingPrice"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="loading.table"
          @filterColumns="filterColumns"
        ></ab-table>
      </template>

      <template #page>
        <ab-page
          :pageTotal="page.total"
          :currentPage='page.currentPage'
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>
  </div>
</template>

<script>
export default {
  name: 'exchange-rate-list',
  data() {
    return {
      loading: {
        table: false,
        export: false
      },
      formSearch: {},
      columns: [
        {
          props: 'createTime',
          labels: '日期',
          widths: 150
        },
        {
          props: 'currencyIdDesc',
          labels: '币种',
          widths: 150
        },
        {
          props: 'rate',
          labels: '海关汇率',
          widths: 150
        },
        {
          props: 'spotSellingPrice',
          labels: '银行汇率(09:30)',
          widths: 100
        }
      ],
      //列表数据
      tableData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        total: 0
      }
    }
  },

  created() {
    this.searchForm()
  },

  methods: {
    // 币别
    sourceCurrencySelect(row) {
      if (row && row.number) {
        this.formSearch.sourceCurrency = row.number
      } else {
        this.formSearch.sourceCurrency = ''
      }
    },

    // 创建日期
    queryDateChange(value) {
      if (value) {
        this.formSearch.queryDateStart = value[0]
        this.formSearch.queryDateEnd = value[1]
      } else {
        this.formSearch.queryDateStart = ''
        this.formSearch.queryDateEnd = ''
      }
    },

    filterColumns(array) {
      this.columns = array
    },

    searchForm() {
      this.page.currentPage = 1
      this.getDataList()
    },

    resetForm() {
      this.formSearch = {}
    },

    pageSearch(obj) {
      this.page.currentPage = obj.currentPage
      this.page.pageSize = obj.pageSize
      this.getDataList()
    },

    getDataList() {
      this.$post('/cms/customsWorkbench/getPageList', {
        data: this.formSearch,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }, this.loading, 'table').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.tableData = data.result.list
          this.page.total = data.result.total
        }
      })
    },

    // 导出
    exportFile() {
      const excelField = this.columns.map(e => e.props)
      let params = Object.assign({}, { data: this.formSearch }, { excelField: excelField })
      this.$post('/cms/customsWorkbench/exportEntry', params, this.loading, 'export').then(({ data }) => {
        if (data && data.code === 'C0000') {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.style.display = 'none'
          // 字符内容转变成blob地址
          eleLink.href = data.message
          // 触发点击
          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.exchange-rate-list {
  width: 100% !important;
  .el-menu.el-menu--horizontal {
    display: none;
  }
}
</style>
